/**
 * @generated SignedSource<<ebfa8c7e989223e678d566cfa7578734>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorPhotoWrapper_viewer$data = {
  readonly tradePhotosQuery: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly firmName: string | null;
        readonly photo: {
          readonly id: string;
          readonly name: string | null;
          readonly photoLike: {
            readonly photoLikeId?: string | null;
          } | null;
          readonly room: {
            readonly name: string | null;
            readonly urlLabel: string | null;
            readonly value: string | null;
          } | null;
          readonly serviceId: string | null;
          readonly styles: ReadonlyArray<{
            readonly name: string | null;
            readonly urlLabel: string | null;
            readonly value: string | null;
          } | null> | null;
          readonly url: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"interiorsPhotosTracking_tradePhoto">;
        } | null;
        readonly projectId: string | null;
        readonly projectRootId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"MobilePhotoContent_photoNode" | "PhotoContent_photoNode">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "InteriorPhotoWrapper_viewer";
};
export type InteriorPhotoWrapper_viewer$key = {
  readonly " $data"?: InteriorPhotoWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorPhotoWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "urlLabels"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorPhotoWrapper_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "urlLabels",
          "variableName": "urlLabels"
        }
      ],
      "concreteType": "TradePhotoQueryConnection",
      "kind": "LinkedField",
      "name": "tradePhotosQuery",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhotoQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradePhotosQueryOutput",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PhotoContent_photoNode"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MobilePhotoContent_photoNode"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectRootId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firmName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TradePhoto",
                  "kind": "LinkedField",
                  "name": "photo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "interiorsPhotosTracking_tradePhoto",
                      "selections": [
                        (v0/*:: as any*/)
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    },
                    (v0/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TradePhotoStyle",
                      "kind": "LinkedField",
                      "name": "styles",
                      "plural": true,
                      "selections": [
                        (v1/*:: as any*/),
                        (v2/*:: as any*/),
                        (v3/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TradePhotoStyle",
                      "kind": "LinkedField",
                      "name": "room",
                      "plural": false,
                      "selections": [
                        (v2/*:: as any*/),
                        (v1/*:: as any*/),
                        (v3/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhotoLike",
                      "kind": "LinkedField",
                      "name": "photoLike",
                      "plural": false,
                      "selections": [
                        {
                          "condition": "hasUserId",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": [
                                {
                                  "kind": "Variable",
                                  "name": "userId",
                                  "variableName": "userId"
                                }
                              ],
                              "kind": "ScalarField",
                              "name": "photoLikeId",
                              "storageKey": null
                            }
                          ]
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "d8061c753f8cea01891957d9be19cace";

export default node;
